import produce from 'immer';

export const baseBalance = () => ({
  isFetching: true,
});

export const fetchBalance = (actions, state) => {
  return produce(state, (draft) => {
    draft.isFetching = true;
  });
};

export const fetchBalanceSuccess = (actions, state) => {
  const { payload } = actions;

  return produce({ ...state, ...payload }, (draft) => {
    draft.isFetching = false;
  });
};

export const fetchBalanceFailed = (actions, state) => {
  const { error } = actions;
  return produce(state, (draft) => {
    draft.error = error;
    draft.isFetching = false;
  });
};
